import React, { createContext, useContext, useState, useCallback, useRef, useEffect } from 'react';

const LoadingContext = createContext();

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [isGlobalLoading, setLoading] = useState(false);
  const counterRef = useRef(0);
  const timeoutRef = useRef(null);

  const setIsGlobalLoading = useCallback((active) => {
    if (active) {
      counterRef.current += 1;
      setLoading(true);
      // Safety net: auto-clear after 30 s to prevent permanently stuck loader
      // (e.g. if a finally block is skipped due to an unhandled rejection).
      // Resets the counter so subsequent true/false pairs behave correctly.
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        counterRef.current = 0;
        setLoading(false);
      }, 30000);
    } else {
      counterRef.current = Math.max(0, counterRef.current - 1);
      if (counterRef.current === 0) {
        clearTimeout(timeoutRef.current);
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return (
    <LoadingContext.Provider value={{ isGlobalLoading, setIsGlobalLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};
